import { BodyImage } from "./BodyImage";

const BodyImageContainer = () => {

	return (
		<BodyImage />
	);
};

export { BodyImageContainer };
